import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiCardHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiCardHeader',
    variants: {
      sharedTitle: {
        fontSize: theme.sizes[4]
      },
      singleTitle: {
        fontSize: theme.sizes[5]
      }
    }
  };
}
